import * as groceryService from './groceries'

export default groceryService;